module.exports = __webpack_public_path__ + "static/media/add-plus.9975f13f.svg";